module.exports = __webpack_public_path__ + "static/myprofile-249d364704a61ab8d3226b076bf9e837.jpg";